import React, { useEffect, useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Bar,
  BarChart,
  Legend,
} from 'recharts';
import AppMenu from '../components/AppMenu';
import axios from 'axios';
// import DatePicker from 'react-datepicker';
import { DatePicker } from 'antd';
// import 'react-datepicker'
import './Dashboard.css';

const MetricBox = ({ title, data }) => {
  const activePercentage = ((data?.active / data?.total) * 100).toFixed(0);
  const inactivePercentage = ((data?.inactive / data?.total) * 100).toFixed(0);
  const totalPercentage = '100';
  return (
    <div className="metric-box">
      <h2 className="metric-title">{title}</h2>
      <div className="metric-content">
        <div className="metric-values">
          <div className="metric-item">
            <div className="label">Total</div>
            <div className="value total">{data?.total}</div>
          </div>
          <div className="metric-item">
            <div className="label">Active</div>
            <div className="value active">{data?.active}</div>
          </div>
          <div className="metric-item">
            <div className="label">InActive</div>
            <div className="value inactive">{data?.inactive}</div>
          </div>
        </div>
        <div className="metric-bar">
          <div
            className="bar-segment total"
            style={{ width: `${totalPercentage}%` }}
          ></div>
          <div
            className="bar-segment active"
            style={{ width: `${activePercentage}%` }}
          ></div>
          <div
            className="bar-segment inactive"
            style={{ width: `${inactivePercentage}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

const Card = ({ children, className }) => (
  <div className={`card ${className || ''}`}>
    <div className="card-content">{children}</div>
  </div>
);

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [modelUsage, setdashboard] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [timeRange, setTimeRange] = useState('last_7_days');

  const fetchStats = async () => {
    try {
      let response;
      if (timeRange === 'custom') {
        response = await axios.get(
          `${process.env.REACT_APP_API}/api/status?startDate=${startDate.toISOString().split('T')[0]}&endDate=${endDate.toISOString().split('T')[0]}&timeRange=${timeRange}`
        );
      } else {
        response = await axios.get(
          `${process.env.REACT_APP_API}/api/status?timeRange=${timeRange}`
        );
      }
      setData(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };
  const fetchdashboard = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/api/status/dashboard`
      );
      setdashboard(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };
  useEffect(() => {
    fetchStats();
    fetchdashboard();
  }, [startDate, endDate, timeRange]);

  
  return (
    <div style={{ display: 'flex' }}>
      <AppMenu />
      {data ? (
        <div className="dashboard">
          <h1 className="dashboard-title">Analytics Dashboard</h1>

          <div className="metrics-grid">
            <Card>
              <MetricBox title="Organization" data={modelUsage?.organization} />
            </Card>
            <Card>
              <MetricBox title="Users" data={modelUsage?.user} />
            </Card>
            <Card>
              <MetricBox title="API Keys" data={modelUsage?.apiKey} />
            </Card>
            <Card>
              <MetricBox title="Models" data={modelUsage?.Model} />
            </Card>
          </div>
          <div className="filters">
            <div className="filter-item">
              <label>Time Range</label>
              <select
                value={timeRange}
                onChange={(e) => setTimeRange(e.target.value)}
                className="time-range-dropdown"
              >
                <option value="last_7_days">Last 7 Days</option>
                <option value="last_15_days">Last 15 Days</option>
                <option value="last_30_days">Last 30 Days</option>
                <option value="last_60_days">Last 60 Days</option>
                <option value="last_90_days">Last 90 Days</option>
                <option value="custom">Custom</option>
              </select>
            </div>

            {timeRange === 'custom' && (
              <>
                <div className="filter-item">
                  <label>Start Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="date-picker"
                  />
                </div>
                <div className="filter-item">
                  <label>End Date</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    className="date-picker"
                  />
                </div>
              </>
            )}
          </div>

          <style>{`
  .filters {
    display: flex;
    gap: 1.5rem;
    align-items: flex-end;
    margin-bottom: 2rem;
  }

  .filter-item {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .filter-item label {
    font-size: 1rem;
    font-weight: bold;
    color: #F3F4F6;
  }

  .date-picker {
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #374151;
    border-radius: 0.375rem;
    background-color: #1F2937;
    color: #F3F4F6;
    width: 100%;
  }

  .date-picker:focus {
    outline: 2px solid #8B5CF6;
  }

  .time-range-dropdown {
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #374151;
    border-radius: 0.375rem;
    background-color: #1F2937;
    color: #F3F4F6;
    width: 100%;
  }

  .time-range-dropdown:focus {
    outline: 2px solid #8B5CF6;
  }

  /* Adjust the hover and focus states for interactivity */
  .date-picker:hover, .time-range-dropdown:hover {
    background-color: #111827;
    border-color: #8B5CF6;
  }
`}</style>

          <div className="charts-grid">
            <Card style={{ width: '1000px', height: '500px', padding: '20px' }}>
              <h2
                className="chart-title"
                style={{
                  textAlign: 'center',
                  color: '#F3F4F6',
                  marginBottom: '20px',
                  fontSize: '20px',
                }}
              >
                Input Token Usage
              </h2>
              <div
                className="chart-container"
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <LineChart
                  width={900}
                  height={400}
                  data={data?.inputTokenUsage}
                  margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                  <XAxis
                    dataKey="date"
                    stroke="#9CA3AF"
                    tick={{ fill: '#F3F4F6', fontSize: 14 }}
                  />
                  <YAxis
                    stroke="#9CA3AF"
                    tick={{ fill: '#F3F4F6', fontSize: 14 }}
                    domain={[0, 'dataMax + 2']} // Add padding to Y-axis
                  />
                  <Tooltip
                    contentStyle={{
                      backgroundColor: '#1F2937',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#F3F4F6',
                    }}
                    labelStyle={{ color: '#FBBF24' }}
                    itemStyle={{ color: '#F3F4F6' }}
                  />
                  <Line
                    type="monotone"
                    dataKey="value"
                    stroke="#8B5CF6"
                    strokeWidth={3}
                    dot={{ r: 5, fill: '#8B5CF6' }}
                  />
                </LineChart>
              </div>
            </Card>

            <Card style={{ width: '1000px', height: '500px', padding: '20px' }}>
              <h2
                className="chart-title"
                style={{
                  textAlign: 'center',
                  color: '#F3F4F6',
                  marginBottom: '20px',
                  fontSize: '20px',
                }}
              >
                Output Token Usage
              </h2>
              <div
                className="chart-container"
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <LineChart
                  width={900}
                  height={400}
                  data={data?.outputTokenUsage}
                  margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                  <XAxis
                    dataKey="date"
                    stroke="#9CA3AF"
                    tick={{ fill: '#F3F4F6', fontSize: 14 }}
                  />
                  <YAxis
                    stroke="#9CA3AF"
                    tick={{ fill: '#F3F4F6', fontSize: 14 }}
                    domain={[0, 'dataMax + 2']} // Add padding to Y-axis
                  />
                  <Tooltip
                    contentStyle={{
                      backgroundColor: '#1F2937',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#F3F4F6',
                    }}
                    labelStyle={{ color: '#FBBF24' }}
                    itemStyle={{ color: '#F3F4F6' }}
                  />
                  <Line
                    type="monotone"
                    dataKey="value"
                    stroke="#10B981"
                    strokeWidth={3}
                    dot={{ r: 5, fill: '#34D399' }}
                  />
                </LineChart>
              </div>
            </Card>

            <Card
              className="span"
              style={{
                width: '100%',
                height: '500px',
                gridColumn: 'span 2',
                padding: '20px',
                backgroundColor: '#1F2937',
                borderRadius: '10px',
              }}
            >
              <h2
                className="chart-title"
                style={{
                  textAlign: 'center',
                  color: '#F3F4F6',
                  marginBottom: '20px',
                  fontSize: '20px',
                }}
              >
                modelUsage
              </h2>
              <div
                className="chart-container"
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <BarChart
                  width={1000} // Adjusted for wider chart
                  height={400}
                  data={data?.modelUsage}
                  margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
                  barCategoryGap="10%"
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#4B5563" />
                  <XAxis
                    dataKey="modelName"
                    stroke="#D1D5DB"
                    tick={{ fill: '#E5E7EB', fontSize: 14 }}
                    interval={0} // Ensures all labels are visible
                    tickMargin={10} // Adds spacing for X-axis labels
                  />
                  <YAxis
                    stroke="#D1D5DB"
                    tick={{ fill: '#E5E7EB', fontSize: 14 }}
                    domain={[0, 'dataMax + 2']} // Add padding to Y-axis
                  />
                  {/* <Tooltip
        // cursor={{ fill: '#1F2937', opacity: 0.2 }} // Highlight the bar being hovered
        contentStyle={{
          backgroundColor: '#374151',
          border: 'none',
          borderRadius: '8px',
          color: '#F3F4F6',
          fontSize: '14px',
        }}
        itemStyle={{ color: '#F3F4F6', fontSize: '12px' }}
        labelStyle={{ color: '#FBBF24', fontSize: '14px' }}
        position={{ y: 10 }} // Dynamically adjust tooltip position
      /> */}
                  <Legend
                    wrapperStyle={{
                      textAlign: 'center',
                      marginTop: '10px',
                      color: '#E5E7EB',
                      fontSize: '14px',
                    }}
                  />
                  <Bar
                    dataKey="inputTokens"
                    fill="#8B5CF6"
                    radius={[10, 10, 0, 0]}
                    label={{ position: 'top', fill: '#E5E7EB', fontSize: 12 }}
                  />
                  <Bar
                    dataKey="outputTokens"
                    fill="#34D399"
                    radius={[10, 10, 0, 0]}
                    label={{ position: 'top', fill: '#E5E7EB', fontSize: 12 }}
                  />
                </BarChart>
              </div>
            </Card>
          </div>

          <style>{`
        .dashboard {
          min-height: 100vh;
          background-color: #09090B;
          padding: 1.5rem;
        }
 
        .dashboard-title {
          font-size: 1.5rem;
          font-weight: bold;
          color: #ffffff;
          margin-bottom: 1.5rem;
        }
 
        .metrics-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }
 
        .charts-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.5rem;
        }
 
        .card {
          background-color: #111827;
          border: 1px solid #1F2937;
          border-radius: 0.5rem;
          overflow: hidden;
        }
        .metric-box {
  background-color: #1F2937;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.metric-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #F3F4F6;
  margin-bottom: 1rem;
}
.metric-content {
  display: flex;
  flex-direction: column;
}
.metric-values {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.metric-item {
  text-align: center;
}
.label {
  font-size: 0.875rem;
  color: #9CA3AF;
  margin-bottom: 0.25rem;
}
.value {
  font-size: 1.5rem;
  font-weight: bold;
}
.value.total {
  color: #8B5CF6;
}
.value.active {
  color: #FBBF24;
}
.value.inactive {
  color: #34D399;
}
.metric-bar {
  height: 1.75rem;
  background-color: #374151;
  border-radius: 0.375rem;
  overflow: hidden;
  display: flex;
}
.bar-segment {
  height: 100%;
}
.bar-segment.total {
  background-color: #8B5CF6;
}
.bar-segment.active {
  background-color: #FBBF24;
}
.bar-segment.inactive {
  background-color: #34D399;
}
/* Update the dashboard background color */
.dashboard {
  background-color: #111827;
}
/* Update the card background color */
.card {
  background-color: #1F2937;
  border-color: #374151;
}
/* Update text colors */
.dashboard-title,
.chart-title {
  color: #F3F4F6;
}
 
        .card-content {
          padding: 1.5rem 1rem 1rem;
        }
 
        .metric-box {
          background-color: #111827;
          border-radius: 0.5rem;
          padding: 1.5rem;
        }
 
        .metric-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #ffffff;
          margin-bottom: 1rem;
        }
 
        .metric-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
        }
 
        .metric-item {
          text-align: center;
        }
 
        .percentage {
          font-size: 1.875rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
        }
 
        .percentage.total {
          color: #818CF8;
        }
 
        .percentage.active {
          color: #34D399;
        }
 
        .percentage.inactive {
          color: #F87171;
        }
 
        .label {
          font-size: 0.875rem;
          color: #9CA3AF;
        }
 
        .value {
          font-size: 1.125rem;
          color: #D1D5DB;
        }
 
        .chart-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #ffffff;
          margin-bottom: 1rem;
        }
 
        .chart-container {
          height: 16rem;
        }
 
        .chart {
          color: #D1D5DB;
        }
 
        @media (max-width: 768px) {
          .metrics-grid,
          .charts-grid {
            grid-template-columns: 1fr;
          }
          .metric-grid {
            gap: 1rem;
          }
        }
 
        .charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}
.card {
  background-color: #1E293B;
  border: 1px solid #374151;
  border-radius: 0.5rem;
  overflow: hidden;
}
.card-content {
  padding: 1.5rem;
}
.chart-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #F3F4F6;
  margin-bottom: 1rem;
}
.chart-container {
  height: 300px;
  width: 100%;
}
@media (max-width: 1024px) {
  .charts-grid {
    grid-template-columns: 1fr;
  }
}
      `}</style>
        </div>
      ) : (
        // Empty parentheses need content - add loading state or fallback UI
        <div>Loading...</div>
      )}
    </div>
);};

export default Dashboard;
